var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_91_102)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3125 18.5938C5.3125 17.8893 5.59235 17.2136 6.0905 16.7155C6.58864 16.2174 7.26427 15.9375 7.96875 15.9375H77.0312C77.7357 15.9375 78.4114 16.2174 78.9095 16.7155C79.4076 17.2136 79.6875 17.8893 79.6875 18.5938C79.6875 19.2982 79.4076 19.9739 78.9095 20.472C78.4114 20.9701 77.7357 21.25 77.0312 21.25H7.96875C7.26427 21.25 6.58864 20.9701 6.0905 20.472C5.59235 19.9739 5.3125 19.2982 5.3125 18.5938ZM42.5 31.875C43.2045 31.875 43.8801 32.1549 44.3783 32.653C44.8764 33.1511 45.1562 33.8268 45.1562 34.5312V65.3066L56.5569 53.9006C57.0556 53.4019 57.7321 53.1216 58.4375 53.1216C59.1429 53.1216 59.8194 53.4019 60.3181 53.9006C60.8169 54.3994 61.0971 55.0759 61.0971 55.7812C61.0971 56.4866 60.8169 57.1631 60.3181 57.6619L44.3806 73.5994C44.1339 73.8467 43.8408 74.043 43.5181 74.1769C43.1953 74.3108 42.8494 74.3797 42.5 74.3797C42.1506 74.3797 41.8047 74.3108 41.4819 74.1769C41.1592 74.043 40.8661 73.8467 40.6194 73.5994L24.6819 57.6619C24.1831 57.1631 23.9029 56.4866 23.9029 55.7812C23.9029 55.0759 24.1831 54.3994 24.6819 53.9006C25.1806 53.4019 25.8571 53.1216 26.5625 53.1216C27.2679 53.1216 27.9444 53.4019 28.4431 53.9006L39.8438 65.3066V34.5312C39.8438 33.8268 40.1236 33.1511 40.6217 32.653C41.1199 32.1549 41.7955 31.875 42.5 31.875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_91_102",
    x: -4,
    y: 0,
    width: 93,
    height: 93,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_102"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_102",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.11755aa1214c1a7151a5dd095cc1dfbc.svg";
export { ForwardRef as ReactComponent };